<template>
  <HeaderNav/>
  <GetCalls/>
  <FooterNav/>
</template>


<script>
import GetCalls from '@/components/GetCalls.vue'
import HeaderNav from '@/components/HeaderNav.vue'
import FooterNav from '@/components/FooterNav.vue'

export default {
  name: 'App',
  components: {
    GetCalls,HeaderNav,FooterNav
  }
}
</script>
